<template>
  <v-menu
    bottom
    offset-y
    left
    content-class="userblock-dropdown"
    nudge-top="-10"
    nudge-right="0"
    transition="slide-y-transition"
    v-if="userProfile"
  >
    <v-btn dark icon slot="activator" class="ml-2 mr-2">
      <v-avatar size="36" color="white">
        <v-img :src="userProfile.photoUrl" alt="alt"></v-img>
      </v-avatar>
    </v-btn>
    <div style="width:100%" class="dropdown-content">
      <v-list>
        <v-list-tile style="padding:5px; background-color:rgb(0, 174, 239);">
          <v-list-tile-avatar>
            <v-img :src="userProfile.photoUrl"></v-img>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title style="font-size:85%;" class="white--user">{{userProfile.user_id}}</v-list-tile-title>
            <v-list-tile-sub-title style="font-size:12px;" class="white--user">{{userProfile.email}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list class="dropdown-list">
        <v-list-tile btn v-on:click="showProfile">
          <i class="far fa-user mr-3 primary--text"></i>
          <span>Perfil de Usuario</span>
        </v-list-tile>
        <v-list-tile btn v-on:click="logoutUser">
          <i class="fas fa-sign-out-alt mr-3 error--text"></i>
          <span>Cerrar sesión</span>
        </v-list-tile>
      </v-list>
    </div>
  </v-menu>
</template>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/imports/EventBus";

export default {
  data() {
    return {
      title: "User"
    };
  },
  computed: {
    ...mapGetters(["userProfile"])
  },
  mounted() {
 
  },
  methods: {
    showProfile() {
      this.$root.$emit("showUserProfile");
    },
    logoutUser() {
      this.$store.dispatch("getProfile", null);
      this.$root.$emit("showLoading", "Saliendo del sistema..");
      this.$store.dispatch("logoutUser").finally(() => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("tokenPassword");                
        this.$router.push("/session/login");
        location.reload();
        this.$root.$emit("hideLoading");
      });
    }
  }
};
</script>
<style>
.white--user {
  color: #fff !important;
  caret-color: #fff !important;
}
</style>
